import wixWindow from 'wix-window';
// import wixAnimations from 'wix-animations'
// import { timeline } from 'wix-animations';

// ...

let formFactor = wixWindow.formFactor;

$w.onReady(function () {
    if (formFactor === "Mobile") {
        $w("#columnStrip2").background.src = "wix:image://v1/fee50a_ff84ba46acb049c0a58ffaa4f2a284c0~mv2.png/HeaderMobile.png#originWidth=446&originHeight=631"

    }

});

function setAnchors() {
    // /// click scroll
    // $w("#boxAnchor1").onClick((event) => {
    //     $w("#boxText1").scrollTo()
    // });
    // $w("#boxAnchor2").onClick((event) => {
    //     $w("#boxText2").scrollTo()
    // });
    // $w("#boxAnchor3").onClick((event) => {
    //     $w("#boxText3").scrollTo()
    // });
    // $w("#boxAnchor4").onClick((event) => {
    //     $w("#boxText4").scrollTo()
    // });
    // /// enter
    // $w("#groupText1").onViewportEnter((event) => {
    //     resetAnchorsStyle()
    //     $w("#boxAnchor1").style.backgroundColor = "#000"
    // });
    // $w("#groupText2").onViewportEnter((event) => {
    //     resetAnchorsStyle()
    //     $w("#boxAnchor2").style.backgroundColor = "#000"
    // });
    // $w("#groupText3").onViewportEnter((event) => {
    //     resetAnchorsStyle()
    //     $w("#boxAnchor3").style.backgroundColor = "#000"
    // });
    // $w("#groupText4").onViewportEnter((event) => {
    //     resetAnchorsStyle()
    //     $w("#boxAnchor4").style.backgroundColor = "#000"
    // });

    // ///

    // $w("#boxAnchor1b").onClick((event) => {
    //     $w("#boxText1b").scrollTo()
    // });
    // $w("#boxAnchor2b").onClick((event) => {
    //     $w("#boxText2b").scrollTo()
    // });
    // $w("#boxAnchor3b").onClick((event) => {
    //     $w("#boxText3b").scrollTo()
    // });
    // $w("#boxAnchor4b").onClick((event) => {
    //     $w("#boxText4b").scrollTo()
    // });
    // /// enter
    // $w("#groupText1b").onViewportEnter((event) => {
    //     resetAnchorsStyle()
    //     $w("#boxAnchor1b").style.backgroundColor = "#000"
    // });
    // $w("#groupText2b").onViewportEnter((event) => {
    //     resetAnchorsStyle()
    //     $w("#boxAnchor2b").style.backgroundColor = "#000"
    // });
    // $w("#groupText3b").onViewportEnter((event) => {
    //     resetAnchorsStyle()
    //     $w("#boxAnchor3b").style.backgroundColor = "#000"
    // });
    // $w("#groupText4b").onViewportEnter((event) => {
    //     resetAnchorsStyle()
    //     $w("#boxAnchor4b").style.backgroundColor = "#000"
    // });
    // /// leave
    // // $w("#boxText2").onViewportLeave((event) => {
    // //     resetAnchorsStyle()
    // //     $w("#boxAnchor1").style.backgroundColor = "#000"
    // // });
    // // $w("#boxText3").onViewportLeave((event) => {
    // //     resetAnchorsStyle()
    // //     $w("#boxAnchor2").style.backgroundColor = "#000"
    // // });
    // // $w("#boxText4").onViewportLeave((event) => {
    // //     resetAnchorsStyle()
    // //     $w("#boxAnchor3").style.backgroundColor = "#000"
    // // });

    // function resetAnchorsStyle() {
    //     $w("#boxAnchor1").style.backgroundColor = "#fff"
    //     $w("#boxAnchor2").style.backgroundColor = "#fff"
    //     $w("#boxAnchor3").style.backgroundColor = "#fff"
    //     $w("#boxAnchor4").style.backgroundColor = "#fff"

    //     $w("#boxAnchor1b").style.backgroundColor = "#fff"
    //     $w("#boxAnchor2b").style.backgroundColor = "#fff"
    //     $w("#boxAnchor3b").style.backgroundColor = "#fff"
    //     $w("#boxAnchor4b").style.backgroundColor = "#fff"
    // }
}